/**
 * Split the stripped output of `stripCzkShortUnit` into the leading number
 * and an optional trailing scale suffix (`tis.` / `mil.`). The suffix is
 * recognised only when it appears as the trailing whitespace-delimited
 * token; any other trailing word is treated as part of the number.
 */
export function splitCzkShortSuffix(value: string): { number: string; suffix: string } {
  const trimmed = value.trim();
  const lastSpace = trimmed.lastIndexOf(' ');
  if (lastSpace === -1) return { number: trimmed, suffix: '' };
  const head = trimmed.slice(0, lastSpace);
  const tail = trimmed.slice(lastSpace + 1);
  if (tail === 'tis.' || tail === 'mil.') return { number: head, suffix: tail };
  return { number: trimmed, suffix: '' };
}